jQuery(document).ready(function ($) {
	$('.accordeon .item .toggle').click(function () {
		$(this).parent('.item').toggleClass('open');
	});

	function openAccordionItem(itemId) {
		var item = $('#' + itemId);
		if (!item.length) return;

		item.addClass('open');

		var headerHeight = $('#header').outerHeight();
		var itemOffset   = item.offset().top - headerHeight;

		$('html, body').animate({ scrollTop: itemOffset }, 500);
	}

	if (window.location.hash) {
		openAccordionItem(window.location.hash.substring(1));
	}
});
